import React from 'react';
import quranData from '../data/quranData';
import '../styles/LevelSelector.css';

const LevelSelector = ({ selectedLevel, onLevelChange }) => {
  return (
    <div className="level-selector">
      <h2>Choisissez votre niveau</h2>
      <div className="level-buttons">
        {quranData.levels.map((level) => (
          <button
            key={level.id}
            className={`level-button ${selectedLevel === level.value ? 'selected' : ''}`}
            onClick={() => onLevelChange(level.value)}
          >
            {level.name}
            <span className="level-description">{level.description}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default LevelSelector;
